import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL, tableHeadCellRootTestId } from '../constants';
import { TABLE_SORTING_DIRECTION_ASC, TABLE_SORTING_DIRECTION_DESC } from '../../constants';
export var useTableHeadCell = function useTableHeadCell(_ref, ref) {
  var sortable = _ref.sortable,
      columnId = _ref.columnId,
      rowSortType = _ref.rowSortType,
      rowSortOrder = _ref.rowSortOrder,
      restProps = _objectWithoutProperties(_ref, ["sortable", "columnId", "rowSortType", "rowSortOrder"]);

  var sortingEnabled = !!(sortable && columnId);

  var _useMemo = useMemo(function () {
    if (!sortable || !rowSortOrder || !rowSortOrder.length) {
      return [false, false, false];
    }

    var isColumnSelected = rowSortOrder[0][0] === columnId;
    return [isColumnSelected, isColumnSelected && rowSortOrder[0][1] === TABLE_SORTING_DIRECTION_ASC, isColumnSelected && rowSortOrder[0][1] === TABLE_SORTING_DIRECTION_DESC];
  }, [sortable, rowSortOrder, columnId]),
      _useMemo2 = _slicedToArray(_useMemo, 3),
      isSelected = _useMemo2[0],
      isAscending = _useMemo2[1],
      isDescending = _useMemo2[2];

  var isIconNumerical = !isSelected && rowSortType === TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL;
  var isIconAlphabetical = !isSelected && rowSortType !== TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL;
  return {
    rootProps: _objectSpread(_objectSpread({
      'data-testid': tableHeadCellRootTestId,
      enableContentWrap: false
    }, restProps), {}, {
      columnId: columnId,
      ref: ref,
      sortingEnabled: sortingEnabled,
      'data-sortable': sortingEnabled ? '1' : '0'
    }),
    isSelected: isSelected,
    isIconNumerical: isIconNumerical,
    isIconAlphabetical: isIconAlphabetical,
    isAscending: isAscending,
    isDescending: isDescending
  };
};